export default "data:image/webp;base64,UklGRjoAAABXRUJQVlA4TC0AAAAvJ4AGACATsMggqhTySWWvT0hA+L9UlgWhABqz6AcQTP2fgPDcwf/mxDcZ/i8A"